import type { ViewportRuntime } from '../../utils/visualViewport'

// Keep the deployed key and light/dark choice; retired palettes normalize to Brass.
export const STUDIO_PREFERENCE_KEY = 'minimany:desktop-design:v1'
export type StudioAppearance = 'midnight' | 'daylight'
export const STUDIO_PALETTES = ['brass'] as const
export type StudioPalette = typeof STUDIO_PALETTES[number]
export interface StudioPreference { appearance: StudioAppearance; palette: StudioPalette }
export const DEFAULT_STUDIO_PREFERENCE: StudioPreference = { appearance: 'midnight', palette: 'brass' }
type StorageAccess = Pick<Storage, 'getItem' | 'setItem'>

// Layout eligibility only. The Studio theme applies to every runtime.
export function studioAvailable(runtime: Pick<ViewportRuntime, 'formFactor' | 'displayMode'>): boolean {
  return runtime.formFactor === 'desktop'
    && (runtime.displayMode === 'browser' || runtime.displayMode === 'standalone')
}

export function readStudioPreference(storage: StorageAccess | undefined): StudioPreference {
  try {
    const value = JSON.parse(storage?.getItem(STUDIO_PREFERENCE_KEY) || 'null')
    return { appearance: value?.appearance === 'daylight' ? 'daylight' : 'midnight', palette: 'brass' }
  } catch { return { ...DEFAULT_STUDIO_PREFERENCE } }
}

export function writeStudioPreference(value: StudioPreference, storage: StorageAccess | undefined): boolean {
  try { if (!storage) return false; storage.setItem(STUDIO_PREFERENCE_KEY, JSON.stringify({ appearance: value.appearance, palette: 'brass' })); return true } catch { return false }
}
